import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import axios from 'axios'

gsap.registerPlugin(CSSRulePlugin)
const prod = process.env.NODE_ENV === 'production'
const lib = require('../../library')

const cartUpdateContents = function () {
  const cartContent = document.querySelector(
    '[data-offcanvascart-content]',
  )
  if (!prod) {
    console.log('there has been an update')
  }
  const requestUrl = '/ajax/catalog/cart'
  const instance = axios.create()
  instance
    .get(requestUrl, { timeout: 7000 })
    .then(({ data }) => {
      replaceCart(data)
    })
    .catch((error) => {
      if (prod) {
      } else {
        lib.logError('Stack failed to AJAX load', error)
      }
    })
  function replaceCart(body) {
    cartContent.innerHTML = body
    lib.reInitModules('CartRemoveProduct')
    lib.reInitModules('CartQtyProduct')
  }
}

/*
* CART OPEN CLOSE FUNCTION
* Handles opening and closing off canvas car
* cartUtils.cartOpenClose('open/close')
* */
const cartOpenClose = function (method) {
  const cart = {}
  cart.wrapper = document.querySelector('[data-offcanvascart-wrapper]')
  cart.canvas = cart.wrapper.querySelector('[data-offcanvascart]')
  cart.body = document.querySelector('body')
  cart.screen = cart.wrapper.querySelector('[data-offcanvascart-screen]')
  cart.nav = cart.wrapper.querySelector('[data-offcanvascart-body]')
  const closeClass = 'hidden'
  const bodyOpenCls = 's-scrolling-disabled'

  if (method === 'open') {
    cartUpdateContents()
    handleOpen()
  } else if (method === 'close') {
    cart.body.classList.remove(bodyOpenCls)
    animateOut()
  } else {
    return false
  }

  function handleOpen() {
    cart.wrapper.classList.remove(closeClass)
    cart.canvas.classList.add('fixed')
    cart.canvas.classList.remove('hidden')
    cart.body.classList.add(bodyOpenCls)
    animateIn()
  }

  function animateIn() {
    const tlStack = gsap.timeline({
      defaults: { duration: 0.25, opacity: 0, ease: 'power2.inOut' },
    })
    // Stats
    tlStack
      .fromTo(
        cart.screen,
        {
          opacity: 0,
        },
        {
          opacity: 0.95,
        },
      )
      .fromTo(
        cart.nav,
        {
          x: 30,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
        },
        '<',
      )

    // If there are any data-sequence items, animate those in.
    tlStack.eventCallback('onStart', () => {
      const items = cart.body.querySelectorAll('[data-sequence]')
      const totalMax = 3
      let durationCalc = totalMax / items.length

      if (durationCalc > 0.3) {
        durationCalc = 0.3
      } else if (durationCalc < 0.1) {
        durationCalc = 0.1
      }

      const timing = {
        duration: durationCalc,
        stagger: durationCalc - durationCalc / 1.15,
        delay: 0.1,
      }

      if (items.length) {
        const itemsTl = gsap.timeline({
          defaults: {
            duration: timing.duration,
            opacity: 0,
            ease: 'back',
          },
        })
        itemsTl.from(
          items,
          {
            delay: timing.delay,
            opacity: 0,
            x: 50,
            stagger: timing.stagger,
          },
          '-=.05',
        )
      }
    })
    // lib.reInitDeferModules("GridBg");
  }

  function animateOut() {
    const tlStackOut = gsap.timeline({
      defaults: { duration: 0.3, opacity: 0, ease: 'power2.inOut' },
    })
    // Stats
    tlStackOut
      .to(cart.screen, {
        opacity: 0,
      })
      .to(
        cart.nav,
        {
          x: 30,
          opacity: 0,
        },
        '<',
      )

    tlStackOut.eventCallback('onComplete', () => {
      cart.wrapper.classList.add(closeClass)
      cart.canvas.classList.remove('fixed')
      cart.canvas.classList.add('hidden')
    })
  }
}
export { cartOpenClose, cartUpdateContents }
